interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, total: number): (number | string)[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const pages: (number | string)[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("...");
  pages.push(total);
  return pages;
}

export default function Pagination({
  current,
  totalPages,
  onChange,
}: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = buildPages(current, totalPages);
  const btnBase =
    "flex h-9 min-w-9 items-center justify-center rounded-md px-2.5 text-sm transition-colors";

  return (
    <nav
      aria-label="分页导航"
      className="mt-10 flex flex-wrap items-center justify-center gap-2"
    >
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${btnBase} border border-background-300/70 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300/70 disabled:hover:text-foreground-600`}
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-left-s-line" />
        </span>
        上一页
      </button>

      {pages.map((page, index) =>
        typeof page === "number" ? (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            className={`${btnBase} ${
              page === current
                ? "bg-primary-500 font-semibold text-background-50"
                : "border border-background-300/70 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {page}
          </button>
        ) : (
          <span
            key={`gap-${index}`}
            className="flex h-9 min-w-9 items-center justify-center text-sm text-foreground-400"
          >
            …
          </span>
        ),
      )}

      <button
        type="button"
        disabled={current === totalPages}
        onClick={() => onChange(current + 1)}
        className={`${btnBase} border border-background-300/70 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300/70 disabled:hover:text-foreground-600`}
      >
        下一页
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-right-s-line" />
        </span>
      </button>
    </nav>
  );
}